module.exports = __webpack_public_path__ + "app/invited-entity/list-invited-entity-19sxepRz.html";